import { Button } from '@/components/ui/Button';
import { trackUmamiEvent } from '@/lib/analytics';

type StickyMobileCtaProps = {
  /** Contact passes `true` so the sticky CTA never overlaps its own form/submit button. */
  hidden?: boolean;
};

/**
 * Fixed-bottom "Request a visit" CTA shown on mobile only, matching the
 * mockup's `.mcta`. Hidden `≥960px` (desktop already shows the CTA in the
 * header) and hidden entirely on the Contact page via the `hidden` prop.
 */
export const StickyMobileCta = ({ hidden = false }: StickyMobileCtaProps) => {
  if (hidden) return null;

  return (
    <div className="bg-background/92 border-line fixed inset-x-0 bottom-0 z-[45] border-t px-4 pt-3 pb-[calc(12px+env(safe-area-inset-bottom))] backdrop-blur min-[960px]:hidden">
      <Button
        as="link"
        href="/contact"
        variant="solid"
        block
        onClick={() => trackUmamiEvent('cta_request_visit', { location: 'sticky_mobile' })}
      >
        Request a visit
      </Button>
    </div>
  );
};
